import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";

import { Collapse, Navbar, Container } from "reactstrap";

import routes from "routes.js";

function Header(props) {
  const [isOpen, setIsOpen] = React.useState(false);
  const [brandName, setbrandName] = React.useState();
  console.log("brandName +++++++++++++++++", brandName)
  const [color, setColor] = React.useState("transparent");
  const sidebarToggle = React.useRef();
  const location = useLocation();
  const toggle = () => {
    if (isOpen) {
      setColor("transparent");
    } else {
      setColor("");
    }
    setIsOpen(!isOpen);
  };
  const getBrand = () => {
    routes.map((prop, key) => {
      if (window.location.href.indexOf(prop.layout + prop.path) !== -1) {
        setbrandName(prop.name);
      }
      return null;
    });
  };
  useEffect(() => {
    getBrand();
  });
  const openSidebar = () => {
    document.documentElement.classList.toggle("nav-open");
  };
  const updateColor = () => {
    if (window.innerWidth < 993 && isOpen) {
      setColor("");
    } else {
      setColor("transparent");
    }
  };
  React.useEffect(() => {
    window.addEventListener("resize", updateColor.bind(this));
  });
  React.useEffect(() => {
    if (
      window.innerWidth < 993 &&
      document.documentElement.className.indexOf("nav-open") !== -1
    ) {
      document.documentElement.classList.toggle("nav-open");
      sidebarToggle.current.classList.toggle("toggled");
    }
  }, [location]);

  const [showdis, setShowdis] = useState(false);
  const handleClosedis = () => setShowdis(false);

  return (
    <Navbar
      color={
        props.location.pathname.indexOf("full-screen-maps") !== -1 ? "" : color
      }
      expand="lg"
      className={
        props.location.pathname.indexOf("full-screen-maps") !== -1
          ? ""
          : "" + (color === "transparent" ? "navbar-transparent " : "")
      }
    >
      <Container fluid className="main-header-top-change p-0">
        <div className="topnavbar">
          <div className="logo d-none mobile-show-logo">
            <img src="\logo.svg" alt="img" className="img-fluid" />
          </div>
          <div className="navbar-wrapper">
            <svg
              width="800px"
              height="800px"
              viewBox="0 0 16 16"
              xmlns="http://www.w3.org/2000/svg"
              fill="#fff"
              class="bi bi-three-dots-vertical wallet-btn-sm d-none"
              style={{ width: "20px", height: "20px" }}
              onClick={toggle}
            >
              <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
            </svg>
            <div className="navbar-toggle">
              <button
                type="button"
                ref={sidebarToggle}
                className="navbar-toggler"
                onClick={() => openSidebar()}
              >
                <img
                  src="\assets\main-assets\menu2.svg"
                  alt="img"
                  className="img-fluid"
                />
                {/* <span className="navbar-toggler-bar bar1" />
        <span className="navbar-toggler-bar bar2" />
        <span className="navbar-toggler-bar bar3" /> */}
              </button>
            </div>
            {/* <NavbarBrand href="/">{brandName}</NavbarBrand> */}
          </div>
        </div>
        {/* <NavbarToggler onClick={toggle}>
    <span className="navbar-toggler-bar navbar-kebab" />
    <span className="navbar-toggler-bar navbar-kebab" />
    <span className="navbar-toggler-bar navbar-kebab" />
  </NavbarToggler> */}
        <Collapse isOpen={isOpen} navbar className="justify-content-between">
          {brandName === "Dashboard" && (
            <div className="innnernavbar">
              <div className="left">
                <div>
                  <p className="tokendiv">Chain</p>
                </div>
              </div>
              <div className="right">
                <div className="rightinnner">
                  <div className="inputoutermain">
                    {/* <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      className="ambrinputicon"
                    >
                      <path
                        d="M7.66927 14.5026C3.9026 14.5026 0.835938 11.4359 0.835938 7.66927C0.835938 3.9026 3.9026 0.835938 7.66927 0.835938C11.4359 0.835938 14.5026 3.9026 14.5026 7.66927C14.5026 11.4359 11.4359 14.5026 7.66927 14.5026ZM7.66927 1.83594C4.44927 1.83594 1.83594 4.45594 1.83594 7.66927C1.83594 10.8826 4.44927 13.5026 7.66927 13.5026C10.8893 13.5026 13.5026 10.8826 13.5026 7.66927C13.5026 4.45594 10.8893 1.83594 7.66927 1.83594Z"
                        fill="#A3A3A3"
                      />
                      <path
                        d="M14.6676 15.1676C14.5409 15.1676 14.4143 15.1209 14.3143 15.0209L12.9809 13.6876C12.7876 13.4943 12.7876 13.1743 12.9809 12.9809C13.1743 12.7876 13.4943 12.7876 13.6876 12.9809L15.0209 14.3143C15.2143 14.5076 15.2143 14.8276 15.0209 15.0209C14.9209 15.1209 14.7943 15.1676 14.6676 15.1676Z"
                        fill="#A3A3A3"
                      />
                    </svg>
                    <input
                      type="text"
                      name="full_name"
                      className="ambassadorinput"
                      placeholder="Search Tokens by Name or Symbol..."
                    /> */}
                  </div>
                  <Link to="addtoken">
                    <button className="addbuttonn">Add Chain</button>
                  </Link>
                </div>
              </div>
            </div>
          )}
          {brandName === "All Market" && (
            <div className="innnernavbar">
              <div className="left">
                <div>
                  <p className="tokendiv">Market</p>
                </div>
              </div>
              <div className="right">
                <div className="rightinnner">
                  <div className="inputoutermain">
                    {/* <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      className="ambrinputicon"
                    >
                      <path
                        d="M7.66927 14.5026C3.9026 14.5026 0.835938 11.4359 0.835938 7.66927C0.835938 3.9026 3.9026 0.835938 7.66927 0.835938C11.4359 0.835938 14.5026 3.9026 14.5026 7.66927C14.5026 11.4359 11.4359 14.5026 7.66927 14.5026ZM7.66927 1.83594C4.44927 1.83594 1.83594 4.45594 1.83594 7.66927C1.83594 10.8826 4.44927 13.5026 7.66927 13.5026C10.8893 13.5026 13.5026 10.8826 13.5026 7.66927C13.5026 4.45594 10.8893 1.83594 7.66927 1.83594Z"
                        fill="#A3A3A3"
                      />
                      <path
                        d="M14.6676 15.1676C14.5409 15.1676 14.4143 15.1209 14.3143 15.0209L12.9809 13.6876C12.7876 13.4943 12.7876 13.1743 12.9809 12.9809C13.1743 12.7876 13.4943 12.7876 13.6876 12.9809L15.0209 14.3143C15.2143 14.5076 15.2143 14.8276 15.0209 15.0209C14.9209 15.1209 14.7943 15.1676 14.6676 15.1676Z"
                        fill="#A3A3A3"
                      />
                    </svg>
                    <input
                      type="text"
                      name="full_name"
                      className="ambassadorinput"
                      placeholder="Search Tokens by Name or Symbol..."
                    /> */}
                  </div>
                  <Link to="addmarket">
                    <button className="addbuttonn">Add Market</button>
                  </Link>
                </div>
              </div>
            </div>
          )}
          {brandName === "Market Detail" && (
            <div className="innnernavbar">
              <div className="left">
                <div>
                  <p className="tokendiv">Market Detail</p>
                </div>
              </div>
            </div>
          )}
            {brandName === "Pair Detail" && (
            <div className="innnernavbar">
              <div className="left">
                <div>
                  <p className="tokendiv">Pair Detail</p>
                </div>
              </div>
            </div>
          )}
          {brandName === "Add Market" && (
            <div className="innnernavbar">
              <div className="left formarket">
                <div className="fornetwork">
                  <p className="tokendiv">Add Market</p>
                  {/* <Link to="/admin/addnetwork">
                    <button className="market">Add Network</button>
                  </Link> */}
                </div>
              </div>
            </div>
          )}
          {brandName === "Add Network" && (
            <div className="innnernavbar">
              <div className="left formarket">
                <div className="fornetwork">
                  <p className="tokendiv">Add Network</p>

                </div>
              </div>
            </div>
          )}
          {brandName === "Token details" && (
            <div className="innnernavbar">
              <div className="left">
                <div>
                  <p className="tokendiv">Chain details</p>
                </div>
              </div>
            </div>
          )}
          {brandName === "Add Token" && (
            <div className="innnernavbar">
              <div className="left">
                <div>
                  <p className="tokendiv">Add Chain</p>
                </div>
              </div>
            </div>
          )}

          {brandName === "Pairs" && (
            <div className="innnernavbar">
              <div className="left formarket">
                <div className="fornetwork">
                  <p className="tokendiv">Pairs</p>
                  <div className="parentsearch">
                    {/* <div className="searchmain">
                      <input type="text" placeholder="Search Pairs by Name or Symbol..." />
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M9.58366 18.1251C4.87533 18.1251 1.04199 14.2917 1.04199 9.58342C1.04199 4.87508 4.87533 1.04175 9.58366 1.04175C14.292 1.04175 18.1253 4.87508 18.1253 9.58342C18.1253 14.2917 14.292 18.1251 9.58366 18.1251ZM9.58366 2.29175C5.55866 2.29175 2.29199 5.56675 2.29199 9.58342C2.29199 13.6001 5.55866 16.8751 9.58366 16.8751C13.6087 16.8751 16.8753 13.6001 16.8753 9.58342C16.8753 5.56675 13.6087 2.29175 9.58366 2.29175Z" fill="white" fill-opacity="0.36" />
                        <path d="M18.3335 18.9583C18.1752 18.9583 18.0169 18.9 17.8919 18.775L16.2252 17.1083C15.9835 16.8666 15.9835 16.4666 16.2252 16.225C16.4669 15.9833 16.8669 15.9833 17.1085 16.225L18.7752 17.8916C19.0169 18.1333 19.0169 18.5333 18.7752 18.775C18.6502 18.9 18.4919 18.9583 18.3335 18.9583Z" fill="white" fill-opacity="0.36" />
                      </svg>
                    </div> */}
                    <Link to="/admin/addpairs">
                    <button className="addpair">Add Pair</button>
                    </Link>
                  </div>

                </div>
              </div>
            </div>
          )}
             {brandName === "Add Pairs" && (
            <div className="innnernavbar">
              <div className="left formarket">
                <div className="fornetwork">
                  <p className="tokendiv">Add Pairs</p>

                </div>
              </div>
            </div>
          )}
         

        </Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;
